import React from 'react';
import { ImageBase } from './Image.base.native';
const Image = ({ ...props }) => {
    return React.createElement(ImageBase, { ...props });
};
export default React.memo(Image);
export { Image };
